import { Injectable } from '@angular/core';
import { BaseData, ImageVariations, StringEncodings } from './image-draw.model';
import { ImageSize } from '../file-reader/v1/file-reading.model';

export type RenderSize = 'preview' | 'full'

@Injectable({
  providedIn: 'root'
})
export class RawImageDataLoaderService {
  private renderPreview: BaseData
  private renderDataFullScale: BaseData

  private loaderWorker: Worker

  getImageData(size: RenderSize): BaseData {
    this.assertImageDataAvailible()
    if (size === 'preview') {
      return this.renderPreview!
    } else {
      return this.renderDataFullScale!
    }
  }

  getImageSize(size: RenderSize): ImageSize {
    this.assertImageDataAvailible()
    if (size === 'preview') {
      return this.renderPreview.headers.imageSize
    } else {
      return this.renderDataFullScale.headers.imageSize
    }
  }

  getStringEncodings(): StringEncodings {
    this.assertImageDataAvailible()
    return this.renderDataFullScale.stringEncodings
  }

  async loadImageFromFile(data: ArrayBuffer) : Promise<void> {
    const renderDataWithVariations = await this.dispatchRenderLoader(data)
    this.renderPreview = renderDataWithVariations.downscale
    this.renderDataFullScale = renderDataWithVariations.fullSize
  }

  private async dispatchRenderLoader(data: ArrayBuffer): Promise<ImageVariations> {
    if (!this.loaderWorker) {
      this.loaderWorker = new Worker(new URL('./image-loader.worker', import.meta.url))
    }
    return await new Promise((resolve, reject) => {
      this.loaderWorker.onmessage = (event: MessageEvent<ImageVariations>) => {
        resolve(event.data)
        this.loaderWorker.onmessage = null
        this.loaderWorker.onerror = null
      }
      this.loaderWorker.onerror = (error) => {
        reject(error)
        this.loaderWorker.onmessage = null
        this.loaderWorker.onerror = null
        console.error(error)
      }
      this.loaderWorker.postMessage(
        data)
    })
  }

  private assertImageDataAvailible() {
    if (!this.renderPreview || !this.renderDataFullScale) {
      throw new Error("Render data not available")
    }
  }
}
